export default __webpack_public_path__ + "static/media/rm.d2dca5c7.png";